import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllSuperAdminUsers } from '@actions/superAdminUsers/fetchAllSuperAdminUsers';
import { getSuperAdminUserPostSuccess } from '@selectors/superAdminUsers';
import usePrevious from 'lib/src/hooks/usePrevious';

const useSuperAdminUsersFetch = (): void => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchAllSuperAdminUsers());
    }, [dispatch]);

    const postSuccess = useSelector(getSuperAdminUserPostSuccess);
    const prevSuccess = usePrevious(postSuccess);

    useEffect(() => {
        if (postSuccess && !prevSuccess) dispatch(fetchAllSuperAdminUsers());
    }, [postSuccess, prevSuccess, dispatch]);
};

export default useSuperAdminUsersFetch;
